import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    constructor(private httpClient: HttpClient) {}
    private headerStyle: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private navigationPos: BehaviorSubject<string> = new BehaviorSubject<string>('');

    // getActiveNavigate() {
    //     return this.headerStyle.value;
    // }
    //
    //
    // setActiveNavigate(value: string) {
    //     this.headerStyle.next(value);
    // }

    getNavigationPos() {
        return this.navigationPos.value;
    }


    setNavigationPos(value: string) {
        this.navigationPos.next(value);
    }
}
